import { DateTime } from "luxon";

import { ZoneDTO } from "../ZoneDTO";

export class StoppageCalc {
  operationId!: number;
  shiftId!: number;
  plantId!: number;
  stoppageId?: number;
  machineName!: string;
  standby?: number;
  preventativeMaintenance?: number;
  operatingDelay?: number;
  nonOperatingDelay?: number;
  maintenanceDown?: number;
  currentStoppageTypeId?: number;
  currentStoppageSubTypeId?: number;
  statusDescription?: string;
  status!: string;
  timeIn?: DateTime;
  stoppageColourHub?: string;
  totalShiftMinutes?: number;
  availability?: number;
  availabilityPercentage?: number;
  utilization?: number;
  utilizationOfAvailability?: number;
  assetUtilization?: number;
  calculatedNod?: number;
  nodDifference?: number;
  totalHours?: number;
  startEngineHours?: number | null;
  endEngineHours?: number | null;
  fuel?: number | null;
  latestRowId?: number;
  latestRowJobType?: number;
  locationId?: number;
  zone?: ZoneDTO;

  constructor(data: Partial<StoppageCalc>) {
    Object.assign(this, data);
  }
}